<template>
  <div class="data-management well-page">
    <v-row no-gutters class="mb-2">
      <v-col cols="12">
        <div class="well-top-wrap">
          <h6>Wells</h6>
          <div class="fd-dm-wells-toolbar">
            <div v-if="isFdNext && wells.length > 0" class="fd-dm-wells-view-toggle">
              <button
                type="button"
                class="fd-dm-wells-view-btn"
                :class="{ 'is-active': wellsView === 'grid' }"
                aria-label="Grid view"
                @click="wellsView = 'grid'"
              >
                <img :src="gridIcon" alt="" class="fd-dm-wells-view-icon" />
              </button>
              <button
                type="button"
                class="fd-dm-wells-view-btn"
                :class="{ 'is-active': wellsView === 'list' }"
                aria-label="List view"
                @click="wellsView = 'list'"
              >
                <img :src="listIcon" alt="" class="fd-dm-wells-view-icon" />
              </button>
            </div>
          </div>
        </div>
        <TabularLoaders v-if="showLoader" :columns="3" :rows="8" />
        <v-row v-else-if="isFdNext && wellsView === 'grid' && wells.length > 0" no-gutters>
          <v-col
            v-for="(well, index) in wells"
            :key="index"
            cols="12"
            md="6"
            lg="3"
            xl="3"
            @click="navigateToSamples(well)"
          >
            <v-sheet class="mb-2 pr-2">
              <v-card elevation="0" class="v-card-asset">
                <v-card-title class="assets_name">{{ well.name }}</v-card-title>
                <v-card-text class="assets-data">
                  <div class="top-info">
                    <div class="go-link">
                      Sample
                      <span>{{ well.counts?.samples ?? 0 }}</span>
                    </div>
                    <div>
                      Tests
                      <span>{{ well.counts?.totalTests ?? 0 }}</span>
                    </div>
                  </div>
                  <div class="test-count">
                    <div>Compositions <span>{{ well.counts?.compositions ?? 0 }}</span></div>
                    <div>Separator Tests <span>{{ well.counts?.separatortests ?? 0 }}</span></div>
                    <div>CCE Tests <span>{{ well.counts?.ccetests ?? 0 }}</span></div>
                    <div>Viscosity Tests <span>{{ well.counts?.viscositytests ?? 0 }}</span></div>
                    <div>DL Tests <span>{{ well.counts?.dltests ?? 0 }}</span></div>
                    <div>CVD Tests <span>{{ well.counts?.cvdtests ?? 0 }}</span></div>
                  </div>
                </v-card-text>
              </v-card>
            </v-sheet>
          </v-col>
        </v-row>
        <v-table v-else-if="wells.length > 0" class="well-table sample-table well-table-data fd-table fd-dm-asset-table">
          <thead>
            <tr class="main-header">
              <th>Well Number</th>
              <th>Number of Samples</th>
              <th>Samples</th>
            </tr>
          </thead>
          <tbody class="well-table-content">
            <tr v-for="(well, index) in wells" :key="index">
              <td @click="navigateToSamples(well)">
                <span class="cursor-pointer clickable-cell well-cell no-bg">{{ well.name }}</span>
              </td>
              <td>{{ well.counts?.samples ?? 0 }}</td>
              <td>
                <div v-if="well.data && well.data.length" class="fd-dm-inline-row">
                  <div class="fd-dm-inline-chips">
                    <span
                      v-for="sample in well.data"
                      :key="sample.id"
                      class="clickable-cell no-bg fd-dm-inline-chip"
                      @click.stop="navigateToSamplesWithSampleId(well, sample.id)"
                    >
                      {{ sample.fluidSampleID }}{{ sample.sampleType ? ` (${sample.sampleType})` : "" }}
                    </span>
                  </div>
                </div>
                <span v-else class="fd-dm-inline-empty">No sample(s) found.</span>
              </td>
            </tr>
          </tbody>
        </v-table>
        <div v-else-if="timeoutMessage != ''" class="no-asset-div timeout">
          <div class="text-center">
            {{ timeoutMessage }}
            <v-icon flat @click="fetchData()" color="blue-darken-3" icon="mdi-reload" size="large"></v-icon>
          </div>
        </div>
        <div class="no-asset-div" v-else-if="wells.length == 0 && showLoader == false && timeoutMessage == ''
          ">
          <h4>No well(s) founds.</h4>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import api from "../../../axiosInterceptor"
import TabularLoaders from "../Loaders/TabularLoaders.vue";
export default {
  name: "SampleWells",
  components: {
    TabularLoaders,
  },
  computed: {
    isFdNext() {
      return document.documentElement.classList.contains("fd-next");
    },
  },
  data() {
    return {
      wells: [],
      well_image: require("../../../assets/Images/Assets/wells.png"),
      showLoader: true,
      timeoutMessage: "",
      wellsView: "grid",
      gridIcon: require("../../../assets/Svg/Icons/view-grid.svg"),
      listIcon: require("../../../assets/Svg/Icons/view-list.svg"),
    };
  },
  methods: {
    fetchData() {
      this.showLoader = true;
      this.timeoutMessage = "";
      const fieldName = this.$route.params.field.replace(/-/g, " ");
      const sanitizedFieldName = fieldName.replace(/\\/g, "/");
      const fieldString = JSON.stringify(sanitizedFieldName);

      api
        .get(`public/api/locations/wells?field=${encodeURIComponent(fieldString)}`)
        .then((response) => {
          if (response && response.data && (response.data.statusCode === 200 || response.data.statusCode === 201)) {
            this.wells = response.data.data.locations
          .sort((a, b) => parseInt(a.name.split("-")[1]) - parseInt(b.name.split("-")[1]));
          }
          else if (response && response.data && response.data.message) {
        this.timeoutMessage = response.data.message;
          }
          else {
            this.timeoutMessage = "Error in fetching wells";
          }
        })
        .catch((error) => {
          this.timeoutMessage = error;
        })
        .finally(() => {
          this.showLoader = false;
        });
    },
    navigateToSamples(well) {
      const wellName = well.name;
      this.$router.push({
        name: "Samples",
        params: { well: wellName },
      });
    },
    navigateToSamplesWithSampleId(well,sampleId) {
      const wellName = well.name.replace(/\s/g, "-");
      this.$router.push({
        name: "Samples",
        params: { well: wellName , sampleId: sampleId},
      });
    },
  },
  mounted() {
    this.fetchData();
  },
};
</script>
